import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_storage_alertsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { fullTextSearch?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean, $top?: number, $skip?: number, $orderby?: { column: ('alert_id' | 'application_name' | 'alert_name' | 'level' | 'enabled' | 'to' | 'cc' | 'bcc' | 'subject' | 'pdf' | 'created_on' | 'created_by' | 'modified_on' | 'modified_by'), order: ('asc' | 'desc') }[], $filter?: { operator: ('and' | 'or'), operands: { numberFilters?: { column: ('level'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: number }[], numberMultiFilters?: { column: ('level'), operation: ('in' | 'notIn'), value: number[] }[], stringFilters?: { column: ('alert_id' | 'application_name' | 'alert_name' | 'to' | 'cc' | 'bcc' | 'subject' | 'created_by' | 'modified_by'), operation: ('equals' | 'notEqual' | 'empty' | 'contains' | 'notContains' | 'startsWith' | 'endsWith' | 'blank' | 'notBlank'), value: string }[], stringMultiFilters?: { column: ('alert_id' | 'application_name' | 'alert_name' | 'to' | 'cc' | 'bcc' | 'subject' | 'created_by' | 'modified_by'), operation: ('in' | 'notIn'), value: string[] }[], dateFilters?: { column: ('created_on' | 'modified_on'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: string }[], booleanFilters?: { column: ('enabled' | 'pdf'), operation: ('equals' | 'notEqual' | 'empty'), value: boolean }[], operator: ('and' | 'or') }[] } }): Promise<{ result?: { alert_id?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, pdf?: boolean, created_on?: string, created_by?: string, modified_on?: string, modified_by?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { fullTextSearch?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean, $keys: string[] }): Promise<{ result?: { alert_id?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, pdf?: boolean, created_on?: string, created_by?: string, modified_on?: string, modified_by?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      fullTextSearch?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean    }) {
      return false;
    }
}
